<template>
    <div id="modal" class="r-isfull-position">
        <div class="r-modal-box r-mtb-20-withauto">
            <div class="r-modal-form r-p-25 r-center-text" >
                <h4 class="r-mb-16">Profilmu Belum Lengkap </h4>
                <div class="r-place-outline r-p-16">
                    <div class="r-center-flex">
                        <p>Kelengkapan Profile</p>
                        <span class="r-ml-auto r-isBold">{{countProgress}}%</span>
                    </div>
                    <div class="r-progress-bar r-mtb-16">
                        <div class="r-progress" :style="`width: ${countProgress}%`"></div>
                    </div>
                </div>
                <p class="r-black-60-text r-mt-16">
                    Silahkan lengkapi profilmu terlebih dahulu minimal 80%, agar kamu bisa melanjutkan melamar di lowongan pekerjaan ini.
                </p>
                <router-link :to="{name: 'Profile'}" @click.native="closeModal()">
                    <button class="r-isExpand r-primary-filled-btn r-large-size r-mtb-16">
                        Lengkapi Sekarang
                    </button>
                </router-link>
                <button class="r-isExpand r-primary-textOnly-btn r-large-size" @click.prevent="closeModal()">
                    Nanti Saja
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import {countProgress} from '@/common/helper'

export default {
    computed:{
        user(){
            return this.$store.getters['auth/getUser']
        },
        countProgress(){
            return countProgress(this.user)
        },
    },
    methods:{
        closeModal(){
            this.$store.dispatch('setModal',null)
        },
    }
}
</script>